/**
 * Context for the app type.
 */
import type { AppType } from '@aurora/shared-types/app';
import { createContext } from 'react';

const AppTypeContext = createContext<AppType | null>(null);

export default AppTypeContext;
